import { ReactNode } from 'react';
import { cx } from '@linaria/atomic';
import { useStepperCardContext } from '../provider/stepper-card.provider';
import { useStepperContext } from '../provider/stepper.provider';

export type StepperContentProps = {
  children: ReactNode[] | ReactNode;
  alwaysRender?: boolean;
  className?: string;
};

export const StepperContent = ({ children, alwaysRender, className, ...rest }: Partial<StepperContentProps>) => {
  const { stepStatus, alwaysRender: globalAlwaysRender } = useStepperContext();
  const { step } = useStepperCardContext();

  if (alwaysRender ?? globalAlwaysRender) {
    return (
      <div
        {...rest}
        className={cx('step-content', className)}
        style={{
          display:
            stepStatus[step] === 'currActive' || stepStatus[step] === 'active' || stepStatus[step] === 'errorActive'
              ? 'block'
              : 'none',
        }}
      >
        {children}
      </div>
    );
  }

  return (
    <>
      {(stepStatus[step] === 'currActive' || stepStatus[step] === 'active' || stepStatus[step] === 'errorActive') && (
        <div {...rest} className={cx('step-content', className)}>
          {children}
        </div>
      )}
    </>
  );
};
